
const axios = require('axios');

export default class HSRestManager {
    static getAccessToken = function (code, successCallback, failureCallback) {
        axios.post('/getHubspotAccessToken', {
            code: code
        }).then((response) => {
            // console.log('login succeed');
            successCallback(response);
        }).catch((error) => {
            // console.log("error is");
            failureCallback(error);
        });
    }

    static getAccessTokenFromRefreshToken = (refresh_token, guest_name, guest_email, guest_company_name, guest_title, successCallback, failureCallback) => {
        axios.post('/getHubspotAccessTokenFromRefreshToken', {
            refresh_token: refresh_token
        }).then((response) => {
            if(response.data && response.data.status == 400) failureCallback(response.data, guest_name, guest_email, guest_company_name, guest_title);
            else successCallback(response, guest_name, guest_email, guest_company_name, guest_title);
        }).catch((error) => {
            failureCallback(error, guest_name, guest_email, guest_company_name, guest_title);
        });
    }

    static checkProfileDetails = (accessToken, instanceURL, reqObj, guest_name, guest_email, guest_company_name, guest_title, successCallback, failureCallback) => {
        var reqData = {
            email: guest_email,
            data: reqObj,
            accessToken: accessToken,
            instanceURL: instanceURL
        }

        axios.post('/getHSProfileDetails', reqData).then((response) => {
            successCallback(response, guest_name, guest_email, guest_company_name, guest_title);
        }).catch((error) => {
            failureCallback(error, guest_name, guest_email, guest_company_name, guest_title);
        });
    }

    static createHSLead = function (accessToken, instanceURL, reqObj, taskSubject, taskDetails, taskStatus, taskDate, successCallback, failureCallback) {
        var reqData = {
            data: reqObj,
            accessToken: accessToken,
            instanceURL: instanceURL
        }

        axios.post('/createHSLead', reqData).then((response) => {
            console.log('createHSLead succeed');
            successCallback(response, taskSubject, taskDetails, taskStatus, taskDate);
        }).catch((error) => {
            console.log("createHSLead error is");
            failureCallback(error, taskSubject, taskDetails, taskStatus, taskDate);
        });
    }

    static createHSActivity = function (accessToken, instanceURL, reqObj, successCallback, failureCallback) {
        var reqData = {
            data: reqObj,
            accessToken: accessToken,
            instanceURL: instanceURL
        }

        axios.post('/createHSActivity', reqData).then((response) => {
            console.log('createHSActivity succeed');
            successCallback(response);
        }).catch((error) => {
            console.log("createHSActivity error is");
            failureCallback(error);
        });
    }

    static createBulkLead = function (accessToken, instanceURL, list, successCallback, failureCallback) {
        var reqData = {
            data: list,
            accessToken: accessToken,
            instanceURL: instanceURL
        }

        axios.post('/createHSBulkLead', reqData).then(response => {
            if(response.data && response.data.status == 400){
                failureCallback(response.data);
            } else {
                successCallback(response);
            }
        }).catch(error => {
            failureCallback(error);
        })
    }

    static getClientIds = function (accessToken, instanceURL, params, successCallback, failureCallback) {
        var reqData = {
            instanceURL: instanceURL,
            params: params,
            accessToken: accessToken
        }
        axios.post('/getHSClientIds', reqData).then(response => {
            successCallback(response);
        }).catch(error => {
            failureCallback(error);
        })
    }

    static createBulkTask = function (accessToken, instanceURL, contactIds, task, successCallback, failureCallback){
        var reqData = {
            accessToken: accessToken,
            instanceURL: instanceURL,
            contactIds: contactIds,
            taskDetails: task.details,
            taskSubject: task.subject,
            taskStatus: task.status,
            taskDate: task.date
        }

        axios.post('/createHSBulkTask', reqData).then(response => {
            successCallback(response);
        }).catch(error => {
            failureCallback(error);
        })
    }
}